import {
  TpvOperatorResult,
  TpvOperatorListItem,
  TpvOperatorDetail,
  OperatorMerchants,
} from '@app/domain/models/tpv/tpv-operator.model';
import {
  TpvOperatorResponseDto,
  TpvOperatorListItemDto,
  TpvOperatorDetailDto,
  OperatorMerchantsDto,
} from '@app/data/dtos/tpv/tpv-operator.dto';

export function mapTpvOperatorResult(dto: TpvOperatorResponseDto): TpvOperatorResult {
  return {
    idUser: Number(dto.id_user ?? 0),
    email: dto.email ?? '',
    polipayAccount: dto.polipay_account ?? '',
    idGestor: Number(dto.id_gestor ?? 0),
    role: { id: Number(dto.rol?.id ?? 0), name: dto.rol?.name ?? '' },
    // El back ecoa el id del path: entero (org) o UUID; no forzar Number (→ NaN).
    idCompany: typeof dto.id_company === 'string' ? dto.id_company : Number(dto.id_company ?? 0),
    merchants: dto.merchants ?? [],
  };
}

/** Item del listado de operadores (§4.B). */
export function mapTpvOperatorListItem(dto: TpvOperatorListItemDto): TpvOperatorListItem {
  const merchants = dto.merchants ?? [];
  return {
    idUser: Number(dto.id_user ?? 0),
    email: dto.email ?? '',
    name: dto.name ?? '',
    isActive: dto.is_active ?? false,
    idGestor: Number(dto.id_gestor ?? 0),
    role: { id: Number(dto.rol?.id ?? 0), name: dto.rol?.name ?? '' },
    // company_wide explícito manda; si no viene, lo inferimos de una allow-list vacía.
    companyWide: dto.company_wide ?? merchants.length === 0,
    merchants,
  };
}

/** Detalle de un operador (`GET …/operators/<id_user>/`). */
export function mapTpvOperatorDetail(dto: TpvOperatorDetailDto): TpvOperatorDetail {
  return {
    ...mapTpvOperatorListItem(dto),
    firstName: dto.first_name ?? '',
    lastName: dto.last_name ?? '',
    phoneNumber: dto.phone_number ?? '',
  };
}

/** Allow-list de comercios de un operador (§4.C). */
export function mapOperatorMerchants(dto: OperatorMerchantsDto): OperatorMerchants {
  const merchants = dto.merchants ?? [];
  return {
    companyWide: dto.company_wide ?? merchants.length === 0,
    merchants,
  };
}
